import script from "./OrgSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./OrgSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./OrgSwitcher.vue?vue&type=style&index=0&id=153cd5fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-153cd5fe"]])

export default __exports__